<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<div class="carousel">
    <div #container class="carousel-container">
        <div *ngIf="list && list.length == 1; else listsTemplate" class="slide-content">
            <div>
                <img src="{{list[0].src}}">
            </div>
            <div class="slide-info">
                <div class="slide-info-title">{{list[0].title}}</div>
                <div [nTooltip]="list[0].info" class="slide-info-sub-title">{{list[0].info}}</div>
                <div (click)="setRouterPath(list[0])" *ngIf="list[0]&&list[0].type=='newfeature'" class="slide-info-link">{{i18n.get('home.search_term_view_btn')}}</div>
                <div (click)="jumpToNewPage(list[0].url)" *ngIf="list[0]&&list[0].url!==''&&list[0].type=='quickstart'" class="slide-info-link">{{i18n.get('home.search_term_view_btn')}}</div>
            </div>
        </div>
        <ng-template #listsTemplate>
            <div (mouseenter)="stop()" (mouseleave)="reset()" *ngFor="let item of list;index as i" class="slide-content">
                <div>
                    <img src="{{item.src}}">
                </div>
                <div class="slide-info">
                    <div class="slide-info-title">{{item.title}}</div>
                    <div [nTooltip]="item.info" class="slide-info-sub-title">{{item.info}}</div>
                    <div (click)="setRouterPath(item)" *ngIf="item&&item.type=='newfeature'" class="slide-info-link">{{i18n.get('home.search_term_view_btn')}}</div>
                    <div (click)="jumpToNewPage(item.url)" *ngIf="item&&item.url!==''&&item.type=='quickstart'" class="slide-info-link">{{i18n.get('home.search_term_view_btn')}}</div>
                </div>
            </div>
            <div (mouseenter)="stop()" (mouseleave)="reset()" *ngIf="list&&list.length>1" class="slide-content">
                <div>
                    <img src="{{list[0].src}}">
                </div>
                <div class="slide-info">
                    <div class="slide-info-title">{{list[0].title}}</div>
                    <div [nTooltip]="list[0].info" class="slide-info-sub-title">{{list[0].info}}</div>
                    <div (click)="setRouterPath(list[0])" *ngIf="list[0]&&list[0].type=='newfeature'" class="slide-info-link">{{i18n.get('home.search_term_view_btn')}}</div>
                    <div (click)="jumpToNewPage(list[0].url)" *ngIf="list[0]&&list[0].url!==''&&list[0].type=='quickstart'" class="slide-info-link">{{i18n.get('home.search_term_view_btn')}}</div>
                </div>
            </div>
        </ng-template>
    </div>
    <div *ngIf="list && list.length > 1" class="carousel-pagination-wrap">
        <ng-container *ngFor="let item of list;index as i">
            <i (click)="setIndex(i)" (mouseleave)="reset()" [ngClass]="{'active': activeIndex===i}"></i>
        </ng-container>
    </div>
</div>
